import { alphabeticalSort, isDeleted } from 'shared'
import { HelpMessage } from 'utils/constants'
import { useNameColumn } from 'components/CIMSTable/common/hooks/useNameColumn'
import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { CIMSTags } from 'components/CIMSTags'
import {
  DocumentChecklistItem,
  useDocumentChecklistsTableContext,
} from '../../../DocumentChecklistsTableContext'
import { getDeepestString } from 'utils/getReactNodeLength'

export const useColumns = (): CIMSColumn<DocumentChecklistItem>[] => {
  const {
    selectOptions: { placementTypesOptions },
  } = useDocumentChecklistsTableContext()
  return [
    useNameColumn({
      help: HelpMessage.Concrete.DocumentChecklists.Name,
      sort: { default: 'ascend' },
    }),
    {
      title: 'Placement Types',
      width: 'auto',
      help: HelpMessage.Concrete.DocumentChecklists.PlacementTypes,
      render: ({ documentChecklistItemToConcreteMaterials }) => (
        <CIMSTags
          tags={documentChecklistItemToConcreteMaterials.map(
            ({ concreteMaterial: { placementType, deleted } }) => ({
              text: placementType,
              strikethrough: isDeleted(deleted),
            })
          )}
        />
      ),
      filter: {
        with: 'callback',
        items: placementTypesOptions
          .map(({ label, value }) => ({
            text: getDeepestString(label),
            value: value ?? '',
          }))
          .sort(alphabeticalSort('text')),
        onFilter: (value, { documentChecklistItemToConcreteMaterials }) =>
          documentChecklistItemToConcreteMaterials.some(
            ({ concreteMaterial }) => concreteMaterial.globalId === value
          ),
      },
    },
  ]
}
